export default [
  {
    "x": 143.645825,
    "y": 41.8341321,
    "angle": -0.5412305603244119,
    "lengthA": 8.037952492293703,
    "lengthB": 4.344589046701467
  },
  {
    "x": 117.421497,
    "y": 66.0851321,
    "angle": 0.6955977107775112,
    "lengthA": 6.189025301066458,
    "lengthB": 3.762203907939439
  },
  {
    "x": 117.421497,
    "y": 18.1991321,
    "angle": 1.5707963267948966,
    "lengthA": 23.958346300000002,
    "lengthB": 12.00620678
  },
  {
    "x": 58.5910232,
    "y": 1.07662979,
    "angle": 0.08976826210215526,
    "lengthA": 51.13871707822413,
    "lengthB": 51.138717486573285
  },
  {
    "x": 0.157496648,
    "y": 18.1991321,
    "angle": -1.5707963267948966,
    "lengthA": 10.8289933,
    "lengthB": 8.259
  },
  {
    "x": 0.157496648,
    "y": 200.075405,
    "angle": -1.3470586238392737,
    "lengthA": 33.805942576419355,
    "lengthB": 19.136749324920572
  },
  {
    "x": 99.7671135,
    "y": 214,
    "angle": -2.9929580972061394,
    "lengthA": 21.25298807979124,
    "lengthB": 17.851207172241367
  },
  {
    "x": 111.830162,
    "y": 173.047912,
    "angle": 1.4650617173412304,
    "lengthA": 8.223108577376875,
    "lengthB": 11.045023966225964
  },
  {
    "x": 117.421497,
    "y": 95.7801321,
    "angle": 1.7882982600362192,
    "lengthA": 36.5986616187274,
    "lengthB": 9.006411968930692
  },
  {
    "x": 156.519497,
    "y": 48.6401321,
    "angle": 1.2875289261612928,
    "lengthA": 11.884910536567324,
    "lengthB": 3.851990117963491
  }
]